import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import LocationUpdate from '../../../Components/LocationUpdate'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useVesselMove } from '../../../APIs/Hooks/VesselHooks'
import { delay } from '../../../Functions/DelayFn'
import { useGlobalContext } from '../../../Contexts/GlobalTriggers'
import { useVesselContext } from '../../../Contexts/Modules/SampleModule/VesselModule'
import { tsMoveVessel } from '../../../Typescript/API_Response'

function AddConfirmDialog({
  moveData,
  setMoveData,
  holdingView,
}: {
  moveData: tsMoveVessel | undefined
  setMoveData: any
  holdingView: boolean
}) {
  const { loginConfig } = useUserContext()
  const { playScanSound } = useGlobalContext()
  const { vesselQuery } = useVesselContext()
  const { mutate: moveVessel } = useVesselMove(
    vesselQuery.data?.VesselID,
    setMoveData,
  )
  return (
    <Dialog open={!!moveData}>
      <DialogTitle sx={{ textAlign: 'center' }}>
        {'Confirm Request'}
      </DialogTitle>
      <DialogContent>
        <LocationUpdate
          primary={{
            title:
              holdingView ? moveData?.Vessel.ParentVesselID ?? ''
              : moveData?.Vessel?.Sample ?
                `${moveData?.Vessel?.Sample?.AnimalID} (${moveData?.Vessel?.Sample?.SampleID})`
              : 'No Sample Contained',
            subtitles:
              holdingView ?
                [
                  getCodeSetLabelLookup(
                    loginConfig,
                    ['VesselTypeID'],
                    moveData?.Vessel.VesselType,
                  ),
                ]
              : [
                  moveData?.Vessel?.Sample?.LineName,
                  getCodeSetLabelLookup(
                    loginConfig,
                    ['SampleRunTypeID'],
                    moveData?.Vessel?.Sample?.SampleType,
                  ),
                  getCodeSetLabelLookup(
                    loginConfig,
                    ['SampleStatusID'],
                    moveData?.Vessel?.Sample?.Status,
                  ),
                ],
          }}
          from={{
            title: moveData?.Vessel.VesselID ?? '',
            subtitles: [
              getCodeSetLabelLookup(
                loginConfig,
                ['KV-Holdings'],
                moveData?.Vessel.HoldingID ?
                  parseInt(moveData?.Vessel.HoldingID)
                : undefined,
              ),
              moveData?.Vessel.VesselPositionHuman,
            ],
          }}
          to={{
            title: moveData?.ToVessel.VesselID ?? '',
            subtitles: [
              getCodeSetLabelLookup(
                loginConfig,
                ['KV-Holdings'],
                typeof moveData?.ToVessel.HoldingID === 'string' ?
                  parseInt(moveData?.ToVessel.HoldingID)
                : moveData?.ToVessel.HoldingID,
              ),
              moveData?.ToVessel.NextPositionHuman,
            ],
          }}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2, alignItems: 'flex-end', display: 'flex' }}>
        <TextField
          label="Rescan Vessel to Confirm"
          autoFocus
          onKeyDown={(e: any) => {
            if ((e.code === 'Enter' || e.code === 'Tab') && e.target.value) {
              playScanSound(true)
              delay(500).then(() => {
                moveVessel({
                  move_vessel: e.target.value,
                  new_pos: moveData?.ToVessel?.NextPosition,
                })
                console.log('move')
              })
            }
          }}
          sx={{ flex: 1, width: 1, mr: 1 }}
        />
        <Box
          sx={{
            flex: 1,
            width: 1,
            ml: 1,
            justifyContent: 'flex-end',
            display: 'flex',
          }}
        >
          <Button
            onClick={() => setMoveData(undefined)}
            color="error"
          >
            Cancel
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default AddConfirmDialog
